(function Module() {
	'use strict';
	require('./sw');
	// leaving this line here so that if this technique is needed again it serves as an example
	//$('body').append(`<script src='lib/angucomplete-alt.min.js'></script>`);
	var app = require('./app/index.js');
	//var app = require('../app/ng1.module.ts').ng1App;

	//	parnell stuff
	var parnellCommon = require('../static/js/imported-parnell-common-modules');
	window._ = require('lodash'); 
	window.moment = require('moment');
	window.dropZoneModule =  require('dropzone');
	window.parnellCommon = parnellCommon;
	parnellCommon.util.masks.apply(app);
	parnellCommon.factory.applicationInsights.apply(app, 'MySynchFactory', 'MySynch Web');

	if('serviceWorker' in navigator) {
		navigator.serviceWorker.register('/js/sw.js', { scope: '../' })
		.then(function(registration) {
				console.log('Service Worker Registered');

				
				
		});
		navigator.serviceWorker.ready.then(function(registration) {
		console.log('Service Worker Ready');
			
		});
		navigator.serviceWorker.addEventListener('message', event => {
	
			var data = "";

			try{
              data = JSON.parse(window._.get(event,'data',""));
			}catch(e){
				console.log("service worker's data property failed to JSON.parse")
			}
			
			
			console.log(data);
            if(!window._.isUndefined(data)){
				var messageType = window._.get(data,'type');
				if(!window._.isUndefined(messageType)){
					
					switch(messageType){
						case "refresh_notification":
							console.log("inside refresh notification");
							console.log("MSF:");
							console.log(window.MSF);
							
							if(_.isUndefined(window.MSF)){
								console.log("@@@@@@@@@@@ window.MSF undefined refreshing... @@@@@");
								window.location.reload();
							}else{
								window.MSF.confirmation.info('An update has been made to mySYNCH. Please refresh your browser by selecting the "reload" button to get the latest changes.',false);
							}
					}
					
				}else{
					console.log("messageType on window was undefined");
				}
			}else{
				console.log("there was no data from the sw event");
			} 
			
		     
	   });
	
	}

	require('./config');

	require('./services/cookie-factory');
	require('./services/api-base.service');
	require('./services/api-factory');
	require('./services/mysynch-factory');
	require('./services/indexeddb.service');
	require('./services/fertility-factory');
	require('./services/weather-factory');
	require('./services/view-authorization-factory');
	require('./services/benchmarking-report.service');
	//require('./services/page-tracker.service');
	require('./services/f360.service');
	require('./services/f360.constant.service');
	require('./services/f360.filter');
	require('./services/f360-chart.service');
	require('./services/audit.service');
	require('./services/util.service');
	require('./error/error.controller');
	require('./breeding/codes.programs.controller');
	require('./breeding/codes.basic.controller');
	require('./breeding/codes.lactation1.controller');
	require('./breeding/codes.lactation2.controller');

	//require('./dashboards/kpi.dashboard.controller');
	require('./dashboards/fertility.dashboard.controller');
	require('./dashboards/cohort.detail.controller');
	require('./dashboards/technicians.dashboard.controller');
	require('./dashboards/sires.dashboard.controller');
	require('./dashboards/benchmarking.controller');
	require('./dashboards/fertilityanalysis.controller');
	require('./dashboards/multi-farm-dashboard.controller.js');

	require('./directives/pnl-match.directive');
	require('./directives/tabset.directive');
	require('./directives/validation.directive');
	require('./directives/popup-table.directive');
	require('./directives/masks.directive');
	require('./directives/check-online.directive');
	require('./directives/breadcrumb.directive');
	require('./directives/table-sortable.directive');
	require('./directives/popup-nav-menu.directive');
	require('./directives/utility-directives');

	require('./filters/table-sortable.filter');
	require('./filters/utility-filters');
	require('./filters/demo-user-filter.filter');


	//require('./farms/farm.admin.users.controller');
	require('./farms/farm.breeding-codes.controller');
	require('./farms/farm.details.controller');
	

	require('./farms/herd.costs.controller');
	require('./farms/farm.goal.mgmt.controller');
	require('./farms/my-farm-ranks.controller');

	require('./resources/videos.list.controller');
	require('./resources/white-papers.controller');
	require('./resources/slides.controller');
	require('./services/selected-farm.service');
	//require('./users/user.new.controller');
	require('./notifications/notifications.controller');
	require('./confirmation/confirmation.controller');

	require('./fertility360report/fertility360report.controller');
	
	require('./fertility360report/v1.3/evaluation-overview-v1.3.controller');
	require('./fertility360report/v1.3/section-page-v1.3.controller');
	require('./fertility360report/v1.3/lameness-scoring-v1.3.controller');
	require('./fertility360report/v1.3/body-scoring-v1.3.controller');
	require('./fertility360report/v1.3/result-write-report-v1.3.controller');
	require('./fertility360report/v1.3/review-draft-report-v1.3.controller');

	require('./fertility360report/v2.0/evaluation-overview-v2.0.controller');
	require('./fertility360report/v2.0/section-page-v2.0.controller');
	require('./fertility360report/v2.0/lameness-scoring-v2.0.controller');
	require('./fertility360report/v2.0/body-scoring-v2.0.controller');
	require('./fertility360report/v2.0/result-write-report-v2.0.controller');
	require('./fertility360report/v2.0/review-draft-report-v2.0.controller');

	require('./fertility360report/published-report.controller');
	require('./fertility360report/v1.3/published-report-v1.3.controller');
	require('./fertility360report/v2.0/published-report-v2.0.controller');

	require('./admin/farm.new.controller');

	require('./eMM/emm-retrieve-shotlist.controller.js');
	require('./eMM/emm-field-reports.controller.js');
	
	require('./pythoncharts/seasonal.trends.controller');

	require('./templates');

	require('./app/components/select-farm.component');

	require('./app/ng1.app.component');
	

})();
